import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
  error: null,
  filter: false,
  loading: false,
  pagination: null,
  payment: null,
  payments: null,
  exportedPayments: null,
};

const payments = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CREATE_PAYMENT_START:
      return updateObject(state, {
        error: null,
        loading: true,
      });
    case actionTypes.CREATE_PAYMENT_SUCCESS:
      return updateObject(state, {
        payment: action.payment,
        error: null,
        loading: false,
      });
    case actionTypes.CREATE_PAYMENT_FAILED:
      return updateObject(state, {
        error: action.error,
        loading: false,
      });
    case actionTypes.EVALUATE_PAYMENT_START:
      return updateObject(state, {
        error: null,
        loading: true,
      });
    case actionTypes.EVALUATE_PAYMENT_SUCCESS:
      let status = 'For Evaluation';
      if (action?.payment?.status === 1) {
        status = 'Approved';
      } else if (action?.payment?.status === 0) {
        status = 'Disapproved';
      }
      return updateObject(state, {
        payment: action.payment,
        payments: state.payments.map((x) =>
          x.id === action.payment.id ? { ...x, status: status } : x
        ),
        error: null,
        loading: false,
      });
    case actionTypes.EVALUATE_PAYMENT_FAILED:
      return updateObject(state, {
        error: action.error,
        loading: false,
      });
    case actionTypes.FETCH_PAYMENTS_START:
      return updateObject(state, {
        error: null,
        loading: true,
      });
    case actionTypes.FETCH_PAYMENTS_SUCCESS:
      return updateObject(state, {
        payments: action.payments,
        pagination: action.pagination,
        filter: false,
        error: null,
        loading: false,
      });
    case actionTypes.FETCH_PAYMENTS_FAILED:
      return updateObject(state, {
        error: action.error,
        loading: false,
      });
    case actionTypes.FILTER_PAYMENTS_START:
      return updateObject(state, {
        error: null,
        loading: true,
      });
    case actionTypes.FILTER_PAYMENTS_SUCCESS:
      return updateObject(state, {
        payments: action.payments,
        pagination: action.pagination,
        filter: true,
        error: null,
        loading: false,
      });
    case actionTypes.FILTER_PAYMENTS_FAILED:
      return updateObject(state, {
        error: action.error,
        loading: false,
      });
    case actionTypes.EXPORT_PAYMENTS_START:
      return updateObject(state, {
        error: null,
        loading: true,
      });
    case actionTypes.EXPORT_PAYMENTS_SUCCESS:
      return updateObject(state, {
        exportedPayments: action.exportedPayments,
        error: null,
        loading: false,
      });
    case actionTypes.EXPORT_PAYMENTS_FAILED:
      return updateObject(state, {
        error: action.error,
        loading: false,
      });
    case actionTypes.RESET_PAYMENTS:
      return updateObject(state, initialState);
    default:
      return state;
  }
};

export default payments;
